module.exports = __webpack_public_path__ + "img/partLogo03.b09d5891.png";